export const themeColorTypes = {
    dark: "dark",
    light: "light"
}